import endpoints from "./endpoints.js";

let http;
let token;

const oauth = {
  TOKEN_TYPE_HINT: "",
  GRANT_TYPE: "",
};
const auth = {
  username: "",
  password: "",
};

const init = ({ config, http: _http, token: _token }) => {
  if (!config || typeof config.OAUTH !== "object") return;

  http = _http;
  token = _token;

  endpoints.init(config);

  oauth.TOKEN_TYPE_HINT = config.OAUTH.TOKEN_TYPE_HINT;
  oauth.GRANT_TYPE = config.OAUTH.GRANT_TYPE;

  auth.username = config.OAUTH.CLIENT_ID;
  auth.password = config.OAUTH.CLIENT_SECRET;
};

const login = async (username, password, { params = {} } = {}) => {
  const payload = new FormData();
  payload.append("username", username);
  payload.append("password", password);
  payload.append("grant_type", `${oauth.GRANT_TYPE || "password"}`);

  try {
    const { data } = await http.post(`${endpoints.token()}`, payload, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      auth,
      params,
    });

    token.set(data);
    return data;
  } catch (error) {
    let { message, error_description } = error;
    let errorMessage = message || error_description;

    return Promise.reject(errorMessage);
  }
};

const logout = async () => {
  const payload = new FormData();
  payload.append("token", token.get());
  payload.append(
    "token_type_hint",
    `${oauth.TOKEN_TYPE_HINT || "access_token"}`
  );

  try {
    await http.post(`${endpoints.revoke()}`, payload, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      auth,
    });

    token.clear();
    return true;
  } catch (error) {
    let { message, error_description } = error;
    let errorMessage = message || error_description;

    return Promise.reject(errorMessage);
  }
};

const authenticate = async (payload) => {
  try {
    const { data } = await http.post(endpoints.authenticate(), payload);
    return data;
  } catch (error) {
    const { message } = error;
    return Promise.reject(message);
  }
};

const passwordResetRequest = async (email) => {
  try {
    const payload = {
      email,
    };

    const { data } = await http.post(endpoints.passwordResetRequest(), payload);
    return data.valid;
  } catch (error) {
    const { message } = error;
    return Promise.reject(message);
  }
};

const passwordReset = async (userId, verificationToken, password) => {
  try {
    const payload = {
      password,
    };

    const { data } = await http.post(
      endpoints.passwordReset(userId, verificationToken),
      payload
    );
    return data.message;
  } catch (error) {
    const { message } = error;
    return Promise.reject(message);
  }
};

const passwordResetValidate = async (userId, verificationToken) => {
  try {
    const { data } = await http.get(
      endpoints.passwordResetValidate(userId, verificationToken)
    );
    return data.valid;
  } catch (error) {
    const { message } = error;
    return Promise.reject(message);
  }
};

export default {
  init,
  endpoints,
  login,
  logout,
  authenticate,
  passwordResetRequest,
  passwordReset,
  passwordResetValidate,
};
